import React from 'react';

import { graphql, useLazyLoadQuery } from 'react-relay';

import { useGlobalConfig } from '../../common/utils/global-config/useGlobalConfig';

import type { LegacyAgentVersionPickerWithCapabilityQuery } from './__generated__/LegacyAgentVersionPickerWithCapabilityQuery.graphql';
import { LegacyAgentVersionPicker } from './LegacyAgentVersionPicker';

export const LegacyAgentVersionPickerWithCapability = (): React.JSX.Element | null => {
	const { siteId } = useGlobalConfig();
	const versioningData = useLazyLoadQuery<LegacyAgentVersionPickerWithCapabilityQuery>(
		graphql`
			query LegacyAgentVersionPickerWithCapabilityQuery($cloudId: String!) {
				agentStudio_hasVersionCapability(cloudId: $cloudId) @optIn(to: "AgentStudio") {
					__typename
					... on AgentStudioHasVersionCapability {
						hasVersionCapability
					}
				}
			}
		`,
		{
			cloudId: siteId,
		},
	);
	const hasVersionCapability =
		versioningData?.agentStudio_hasVersionCapability?.__typename ===
			'AgentStudioHasVersionCapability' &&
		Boolean(versioningData.agentStudio_hasVersionCapability.hasVersionCapability);

	return hasVersionCapability ? <LegacyAgentVersionPicker /> : null;
};
